// Отступ сверху при появлении административной панели
itsoftApp.createModule("admPanel", function() {

    if ($('#bx-panel').length) {
        $('#panel').removeClass("disable");
        $('#panel').addClass("is-active");
    }
    else {
        $('#panel').addClass("disable");
        $('#panel').removeClass("is-active");
    }

});
